module.exports = __webpack_public_path__ + "static/media/loading.36610c48.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/loading.gif
// module id = 2142
// module chunks = 0